import { CourseTabData, CourseTabGroup, hasSubtabs } from "@vixi/types";
import { FindReturnType } from "@vixi/types";

export function findCourseTab(
  tabGroup: CourseTabGroup,
  cb: (tab: CourseTabData) => boolean,
): FindReturnType<CourseTabData, number> | null {
  for (let i = 0; i < tabGroup.tabs.length; i++) {
    const tab = tabGroup.tabs[i];

    const isValid = cb(tab);
    if (isValid) {
      return {
        value: tab,
        index: i,
        path: [i],
      };
    }
  }

  return null;
}

export function deepFindCourseTab(
  tabData: CourseTabData,
  cb: (tab: CourseTabData) => boolean,
): CourseTabData | null {
  if (cb(tabData)) {
    return tabData;
  }

  if (!hasSubtabs(tabData)) {
    return null;
  }

  for (let i = 0; i < tabData.tabList.tabs.length; i++) {
    const tab = tabData.tabList.tabs[i];
    const foundTab = deepFindCourseTab(tab, cb);
    if (foundTab) {
      return foundTab;
    }
  }

  return null;
}
